import React, { SyntheticEvent, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import SportUnitiesPage from './Unities';
import SportsHallsPage from './Halls';
import SportsDevicesPage from './Devices'; // <-- Import da nova página
import SportButtonEventsPage from './ButtonEvents';
import DownloadQueuePage from './DownloadQueue';
import VideoQueuePage from './VideoQueue';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';
import { t } from 'i18next';

const SportsPage = () => {
  const [value, setValue] = useState('1');

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <HeaderDashboard />
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            mt: { xs: 0, md: '-50px' },
            width: { xs: '100%', md: '70%' },
          }}
        >
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="Dispositivos" value="1" />
            <Tab label={t('sportsPage.sportsFacilities')} value="2" />
            <Tab label={t('sportsPage.sportsCourts')} value="3" />
            <Tab label="Eventos de Acionamento" value="4" />
            <Tab label="Fila de Downloads" value="5" />
            <Tab label="Fila de Processamento de Vídeo" value="6" />
          </TabList>
        </Box>
        <TabPanel value="1"><SportsDevicesPage /></TabPanel>
        <TabPanel value="2"><SportUnitiesPage /></TabPanel>
        <TabPanel value="3"><SportsHallsPage /></TabPanel>
        <TabPanel value="4" sx={{ p: 0 }}><SportButtonEventsPage /></TabPanel>
        <TabPanel value="5" sx={{ p: 0 }}><DownloadQueuePage /></TabPanel>
        <TabPanel value="6" sx={{ p: 0 }}><VideoQueuePage /></TabPanel>
      </TabContext>
    </>
  );
};

export default SportsPage;